export default {
      id: "eggs-usage",
      viewBox: "0 0 41 38",
      url: __webpack_public_path__ + "img/icons.svg#eggs",
      toString: function () {
        return this.url;
      }
    }